import styled from 'styled-components';

export const CatalogueGrid = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(3, minmax(280px, 1fr));
  gap: var(--default-padding);
`;
